import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
import PersonDetails from './PersonDetails';
import { useTranslation } from 'react-i18next';
import {PredictBmiWHR,SetUserInfo,GetUserInfo} from '../../services/api';


const BodyWeightCalculator = (props) => {
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language === 'ar';
    const user_public_id = localStorage.getItem("user_public_id");
    const aiDemo = props.hostname === "aidemo"


    const [height,setHeight] =useState('');
    const [weight,setWeight] =useState('');
    const [waist,setWaist] =useState('');
    const [hips,setHips] = useState('');
    const [age,setAge] =useState('');
    const [gender,setGender] = useState('');
    const [goal,setGoal] =useState('');
    const [sleeping_hours,setSleepingHours] = useState('');
    const [dietary_preference,setDietaryPreferences ] = useState('');
    const [activity_level,setActivityLevel] = useState('');
    const [stress_level,setStressLevel] = useState('');
    const [bodyShape,setBodyShape]=useState(null);
    const [bmiStatus,setBmiStatus]=useState(null);
    const [emptyFields, setEmptyFields] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [personresult,setPersonResult] = useState(localStorage.getItem("personresult")?localStorage.getItem("personresult"):false);
    const [recommendations,setRecommendations] = useState(localStorage.getItem("recommendations")?JSON.parse(localStorage.getItem("recommendations")):null);
    const [videorecommendations,setVideoRecommendations] = useState(localStorage.getItem("videorecommendations")?JSON.parse(localStorage.getItem("videorecommendations")):null);
    const [idealWeight, setIdealWeight] = useState(localStorage.getItem("idealweight")?localStorage.getItem("idealweight"):null);
    const [results, setResults] = useState(localStorage.getItem("results")?JSON.parse(localStorage.getItem("results")):null);
    const [bmi,setBMI]=useState(localStorage.getItem("bmi")?localStorage.getItem("bmi"):null);
    const [whr,setWHR]=useState(localStorage.getItem("whr")?localStorage.getItem("whr"):null);
    


    useEffect(()=>{
        if (user_public_id){

            if(localStorage.getItem("body_shape") && localStorage.getItem("bmi_status")){
                setBodyShape(localStorage.getItem("body_shape"));
                setBmiStatus(localStorage.getItem("bmi_status"));
            }
            
           GetUserInfo(user_public_id)
           .then((response)=>{
             const data = response.data.user_info
             setAge(data.age);
             setWeight(data.weight);
             setHeight(data.height);
             setWaist(data.waist);
             setHips(data.hips);
             setActivityLevel(data.activity_level);
             setStressLevel(data.stress_level);
             setGender(data.gender);
             setDietaryPreferences(data.dietary_preference);
             setSleepingHours(data.sleeping_hours);
             setGoal(data.weight_goal);
             setBodyShape(data.body_shape);
             setBmiStatus(data.bmi_status);
           }).catch((error)=>{console.error('Error:', error);})
        }

    },[user_public_id])
      

    const handleSubmit = async e => {
        e.preventDefault();
        const newEmptyFields = [];
        if (!height) newEmptyFields.push('height');
        if (!weight) newEmptyFields.push('weight');
        if (!age) newEmptyFields.push('age');
        if (!sleeping_hours) newEmptyFields.push('sleeping_hours');
        if (!dietary_preference) newEmptyFields.push('dietary_preference');
        if (!activity_level) newEmptyFields.push('activity_level');
        if (!stress_level) newEmptyFields.push('stress_level');
        if (!gender) newEmptyFields.push('gender');
        if (!goal) newEmptyFields.push('goal');
        if (!waist) newEmptyFields.push('waist');
        if (!hips) newEmptyFields.push('hips');

        if(newEmptyFields.length > 0){
            setEmptyFields(newEmptyFields);
        }else{
            try {
                setIsLoading(true);
                setEmptyFields([]);
                const formData = new FormData();
                formData.append("user_public_id",user_public_id);
                formData.append('height', parseFloat(height));
                formData.append('weight', parseFloat(weight));
                formData.append('age', parseInt(age));
                formData.append('gender', gender);
                formData.append('goal', goal);
                formData.append('sleeping_hours', parseInt(sleeping_hours));
                formData.append('dietary_preference', dietary_preference);
                formData.append('activity_level', activity_level);
                formData.append('stress_level', stress_level);
                formData.append('language',i18n.language);
                formData.append("waist",waist);
                formData.append("hips",hips);
                formData.append("subscription_dt",localStorage.getItem("subscription_dt"));
                
                
                //ibw and recommendations api
                const response = await fetch('https://wellbe-api-298047552813.us-central1.run.app/', {
                    method: 'POST',
                    body: formData
                });
                const data = await response.json();
       
                // macronutrients api 
                const response_macronutrient = await fetch('https://wellbe-api-298047552813.us-central1.run.app/bmr_predict', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                      weight,
                      height,
                      age,
                      gender: gender == "F" ? "female" : "male",
                      activity_level: activity_level.toLocaleLowerCase(),
                      weight_goal: goal == "Loss" ? "lose" : goal.toLocaleLowerCase(),
                    }),
                });
                const data_macronutrient = await response_macronutrient.json();
                  
                // bmi and whr api
                const whr_response = await PredictBmiWHR(formData);
                const whr_data = whr_response.data.payload;
                setBmiStatus(whr_data.BMI_status)
                setWHR(whr_data.WHR)
                setBMI(whr_data.BMI)
                setBodyShape(whr_data.body_shape)
                localStorage.setItem("bmi",whr_data.BMI)
                localStorage.setItem("whr",whr_data.WHR)
                formData.append("bmi_status",whr_data.BMI_status);
                formData.append("body_shape",whr_data.body_shape);
                localStorage.setItem("bmi_status",whr_data.BMI_status)
                localStorage.setItem("body_shape",whr_data.body_shape)
 
        
                if (data.status === "success" && data_macronutrient.protein) {
                    // create user 
                    SetUserInfo(formData)
                    .then((response)=>{
                        if (response.data.status == "success"){
                           console.log("Created User info successfully !!")
                        }
                    }).catch((error)=>{console.error('Error:', error);})

                    setPersonResult(true);
                    localStorage.setItem("personresult",true);
                    setIdealWeight(Math.round(data.payload.ideal_weight));
                    localStorage.setItem("idealweight",Math.round(data.payload.ideal_weight))
                    setRecommendations(data.payload.recommendations);
                    localStorage.setItem("recommendations",JSON.stringify(data.payload.recommendations));
                    setVideoRecommendations(data.payload.recommendations.video_recommendations);
                    localStorage.setItem("videorecommendations",JSON.stringify(data.payload.recommendations.video_recommendations))
                    const proteinGrams = data_macronutrient.protein;
                    const fatGrams = data_macronutrient.fat;
                    const carbsGrams = data_macronutrient.carbs;
                    const totalMacros = proteinGrams + fatGrams + carbsGrams;
                    const proteinPercentage = Math.round((proteinGrams / totalMacros) * 100);
                    const fatPercentage = Math.round((fatGrams / totalMacros) * 100);
                    const carbsPercentage =Math.round( (carbsGrams / totalMacros) * 100);

                    const macronutrientResult = {
                        calories: Math.round(data_macronutrient.BMR),
                        protein: proteinGrams,
                        proteinPercentage: proteinPercentage,
                        fat: fatGrams,
                        fatPercentage: fatPercentage,
                        carbs: carbsGrams,
                        carbsPercentage: carbsPercentage,
                        water: (data_macronutrient.water / 1000).toFixed(1),
                    }

                    setResults(macronutrientResult);
                    localStorage.setItem("results",JSON.stringify(macronutrientResult));
                    

                    setIsLoading(false);
    
                } else {
                    console.error('Error:', response.message);
                    // Handle the error condition here
                }
            } catch (error) {
                console.error('Error:', error);
            }

        }
    };

    const handleClosePersonalDetails =()=>{
        window.location.href = '/';
    }
    
  return ( 
        <div className='bg-ibw pb-5'>
         <Navbar user_id={props.user_id} setUserId={props.setUserId} BodyWeightCalculatorpage={true} hostname={props.hostname} />
         <div className='container'>
            <div className='container pb-5 position-relative'>
                <div className={`position-absolute ${isArabic ? 'start-0' : 'end-0' } p-2`} style={{ zIndex: 1 }}>
                       <button className="btn-close" aria-label="Close" onClick={handleClosePersonalDetails}></button>
                </div>
            {personresult ? (
           
                    <div className='row' style={{border:"1px solid #FF5C28",borderRadius:"10px"}}>
                        {isLoading && (
                            <div className="d-flex justify-content-center align-items-center" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.5)', zIndex: 9999 }}>
                                <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        )}
                        <PersonDetails personresult={personresult} isLoading={isLoading} height={height} setHeight={setHeight} weight={weight} setWeight={setWeight} age={age} setAge={setAge} gender={gender} setGender={setGender} dietary_preference={dietary_preference} setDietaryPreferences={setDietaryPreferences} activity_level={activity_level} setActivityLevel={setActivityLevel} stress_level={stress_level} setStressLevel={setStressLevel} sleeping_hours={sleeping_hours} setSleepingHours={setSleepingHours} goal={goal} setGoal={setGoal} handleSubmit={handleSubmit} emptyFields={emptyFields} waist={waist} setWaist={setWaist} hips={hips} setHips={setHips}/>
                        
                        <div className={`col-md-6 py-5 px-5 text-light ${isArabic ? 'white-section-ibw-2-arabic' : 'white-section-ibw-2'}`}>
                        {/* {aiDemo && (
                            <div className='d-flex justify-content-start'>
                                <div className={`check-dailyplan ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`}>
                                    <a href={`/workoutplan`} className='px-2 d-flex justify-content-center align-items-center' style={{textDecoration:"none",color:"black",fontSize:"0.9em"}}>
                                        <span className='px-1'>
                                        {t('nav.dailyplan')}
                                        </span> 
                                        <span><img src='/assets/images/arrow-goback.png' width="10px" height="10px" style={{transform: isArabic? '' :'rotate(180deg)'}} /></span>
                                    </a>
                                </div>
                            </div>
                        )} */}
                        <div className='row justify-content-center pt-4'>
                            <div className='col-lg-4 results-padding'> 
                                <div className="circle-container">
                                    <div className="circle">
                                        <span className="value">{idealWeight} {t('bodyweight.kg')}</span>
                                        <span class={`label ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`}>IBW</span>
                                    </div>
                                    
                                    <div className="circle">
                                        <span className="value">{results.calories} cal</span>
                                        <span className={`label ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`} >(BMR)</span>
                                    </div>
                                </div>
                                <div className='circle-container' style={{paddingTop:'30px'}}>
                                    <div className="circle">
                                        <span className="value">{bmi}<br></br>{t(`bodyweight.${bmiStatus}`)}</span>
                                        <span className={`label ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`} >(BMI)</span>
                                    </div>

                                    <div className="circle">
                                        <span className="value">{whr}<br></br>{t(`bodyweight.${bodyShape}`)}</span>
                                        <span className={`label ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`} >(WHR)</span>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-8 d-flex justify-content-center pt-3'>
                                <div>
                                   <img src={gender === "F" ? "../assets/images/female.png" : "../assets/images/male.png"} className='body-image' alt="body" />
                                </div>
                                <div className="tracker-container">
                                    <div className="progress-circle" style={{ '--progress': Number(results.carbsPercentage)+'%', '--progress-color': '#ff474c' }}>
                                        <span className="percentage">{results.carbsPercentage}%</span>
                                        <div className={`label ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`}>{t('bodyweight.Carbohydrates')}</div>
                                    </div>

                                    <div className="progress-circle" style={{ '--progress': Number(results.fatPercentage)+'%', '--progress-color': '#ffe000' }}>
                                        <span className="percentage">{results.fatPercentage}%</span>
                                        <div className={`label ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`}>{t('bodyweight.Fat')}</div>
                                    </div>

                                    <div className="progress-circle" style={{ '--progress': Number(results.proteinPercentage)+'%', '--progress-color': '#8bc84e' }}>
                                        <span className="percentage">{results.proteinPercentage}%</span>
                                        <div className={`label ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`}>{t('bodyweight.Protein')}</div>
                                    </div>

                                    <div className="progress-circle" style={{ '--progress': 100+'%', '--progress-color': '#00d0ff' }}>
                                        <span className="percentage">{results.water}L</span>
                                        <div className={`label ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`}>{t('bodyweight.water')}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='pt-4'>
                                <h5 className={`${isArabic ? 'notokufi-bold' : 'avenir-heavy'}`}>{t('bodyweight.Guidelines')}</h5>

                                <div className='row'>
                                    <div className='col-xl-6 pt-3'>
                                        <div className="accordion" id="accordionExample">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingTwo">
                                                <button className={`accordion-button collapsed acc-title ${isArabic ? 'notokufi-bold rtl-arrow' : 'avenir-heavy'}`} type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                    {t('bodyweight.Fitness_Exercises')}
                                                </button>
                                                </h2>
                                                <div id="collapseTwo" className={`accordion-collapse collapse ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`} aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                                <div className="accordion-body">
                                                {recommendations.Fitness_Exercises}
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-xl-6 pt-3'>
                                        <div className="accordion" id="accordionExample">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="heading3">
                                                <button className={`accordion-button collapsed acc-title ${isArabic ? 'notokufi-bold rtl-arrow' : 'avenir-heavy'}`}type="button" data-bs-toggle="collapse" data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                                                {t('bodyweight.Nutritional_Recommendations')}
                                                </button>
                                                </h2>
                                                <div id="collapse3" className={`accordion-collapse collapse ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`} aria-labelledby="heading3" data-bs-parent="#accordionExample">
                                                <div className="accordion-body">
                                                {recommendations.Nutritional_Recommendations}
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-xl-6 pt-3'>
                                        <div className="accordion" id="accordionExample">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="heading4">
                                                <button className={`accordion-button collapsed acc-title ${isArabic ? 'notokufi-bold rtl-arrow' : 'avenir-heavy'}`} type="button" data-bs-toggle="collapse" data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                                                {t('bodyweight.Hydration')}
                                                </button>
                                                </h2>
                                                <div id="collapse4" className={`accordion-collapse collapse ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`} aria-labelledby="heading4" data-bs-parent="#accordionExample">
                                                <div className="accordion-body">
                                                {recommendations.Hydration}
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-xl-6 pt-3'>
                                        <div className="accordion" id="accordionExample">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="heading5">
                                                <button className={`accordion-button collapsed acc-title ${isArabic ? 'notokufi-bold rtl-arrow' : 'avenir-heavy'}`} type="button" data-bs-toggle="collapse" data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                                                {t('bodyweight.Sleep_Recovery')}
                                                </button>
                                                </h2>
                                                <div id="collapse5" className={`accordion-collapse collapse ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`} aria-labelledby="heading5" data-bs-parent="#accordionExample">
                                                <div className="accordion-body">
                                                {recommendations.Sleep_Recovery}
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-xl-6 pt-3'>
                                        <div className="accordion" id="accordionExample">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="heading6">
                                                <button className={`accordion-button collapsed acc-title ${isArabic ? 'notokufi-bold rtl-arrow' : 'avenir-heavy'}`} type="button" data-bs-toggle="collapse" data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                                                {t('bodyweight.Stress_Management')}
                                                </button>
                                                </h2>
                                                <div id="collapse6" className={`accordion-collapse collapse ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`} aria-labelledby="heading6" data-bs-parent="#accordionExample">
                                                <div className="accordion-body">
                                                {recommendations.Stress_Management}
                                                </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className='col-xl-6 pt-3'>
                                        <div className="accordion" id="accordionExample">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="heading7">
                                                <button className={`accordion-button collapsed ${isArabic ? 'notokufi-bold rtl-arrow' : 'avenir-heavy'}`} type="button" data-bs-toggle="collapse" data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                                                {t('bodyweight.Movement_Incorporation')}
                                                </button>
                                                </h2>
                                                <div id="collapse7" className={`accordion-collapse collapse ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`} aria-labelledby="heading7" data-bs-parent="#accordionExample">
                                                <div className="accordion-body">
                                                {recommendations.Movement_Incorporation}
                                                </div>
                                                </div>
                                            </div>
                                        </div> 
                                    </div>
                                </div>
                              
                        </div>

                        <div className="pt-4">
                           <p className={`${isArabic ? 'notokufi-bold' : 'avenir-heavy'}`}>{t('bodyweight.Video')}</p>
                           <div className='row d-flex justify-content-between pt-2 videos-ai'>
                           {Object.entries(videorecommendations).map(([key, value], index) => (
                                    <React.Fragment key={index}>
                                        <div className='col-md-6 d-flex justify-content-between align-items-center py-1'>
                                            <div className={`px-2${isArabic ? 'notokufi-bold' : 'avenir-heavy'}`}>
                                                {t(`bodyweight.${key}`)}
                                            </div>
                                            <div className={`${isArabic ? 'notokufi-regular  watch-video-button-arabic' : 'avenir-regular  watch-video-button'}`}>
                                                <a href={`/content/${value}?code=${key.toUpperCase()}`} className='px-2'>
                                                    {t('bodyweight.WatchVideo')}
                                                </a>
                                            </div>
                                        </div> 
                                    </React.Fragment>
                                ))}
                            </div>
                           
                         </div>
                        </div>

                    </div>

            ):(
            <div className='row' style={{border:"1px solid #FF5C28",borderRadius:"10px"}}>
                <div className={`col-md-6 ${isArabic ? 'white-section-ibw-1-arabic' : 'white-section-ibw-1'}`}>
                    <div><img src="../assets/images/ibw.png" className='ibw-img'/></div>
                    <div className='text-center'>
                        <h2 className={`${isArabic ? 'notokufi-bold' : 'avenir-heavy'}`} >{t('bodyweight.title')}</h2> 
                        <h5 className={`${isArabic ? 'notokufi-regular' : 'avenir-book'}`}>{t('bodyweight.text')}</h5>
                    </div>
                </div>
                

                <PersonDetails isLoading={isLoading} height={height} setHeight={setHeight} weight={weight} setWeight={setWeight} age={age} setAge={setAge} gender={gender} setGender={setGender} dietary_preference={dietary_preference} setDietaryPreferences={setDietaryPreferences} activity_level={activity_level} setActivityLevel={setActivityLevel} stress_level={stress_level} setStressLevel={setStressLevel} sleeping_hours={sleeping_hours} setSleepingHours={setSleepingHours} goal={goal} setGoal={setGoal} handleSubmit={handleSubmit} emptyFields={emptyFields} waist={waist} setWaist={setWaist} hips={hips} setHips={setHips}/>
             
             </div>
             )
            }
          </div>
         </div>
        </div>
   
  );
};

export default BodyWeightCalculator;
